import React from "react";
import NavbarUni from "./componentes/headUni";
import "./aboutUs/AboutUs.css";
import { Card, Col, Container, Row } from "react-bootstrap";
import { AwardFill, CheckCircleFill, PhoneFill } from "react-bootstrap-icons";
import Testimonials from "./aboutUs/testimonials";
import Contact from "./aboutUs/contact";
import FooterPublic from "./FooterPublic";

const AboutUs = () => {
    return (
        <div style={{ paddingTop: '60px' }}>
            <NavbarUni />
            <div className="hero-container d-flex align-items-center justify-content-center" >
                <h1 className="hero-text">REY MIDAS CAPS</h1>
                <div className="scroll-down">
                    <span className="arrow"></span>
                </div>
            </div>
            <Container className="my-5">
                <h2 className="text-uppercase text-muted mb-3 fs-6">Acerca de Nosotros</h2>
                <h3 className="fw-bold text-black fs-2">Conoce quienes somos</h3>
                <p>
                    En Rey Midas Caps, nos dedicamos a distribuir gorras de alta calidad en Colombia, ofreciendo estilo, comodidad y durabilidad.
                    Nos apasiona la moda y nos comprometemos a proporcionar una experiencia de compra excepcional, manteniéndonos al tanto de las
                    últimas tendencias. Valoramos la confianza de nuestros clientes y nos esforzamos por ofrecer transparencia, integridad y respeto
                    en todas nuestras operaciones. ¡Únete a nosotros para llevar tu estilo al siguiente nivel!
                </p>
                <h4 className="mt-4 fw-bold fs-2 text-black">¿Por qué comprar con nosotros?</h4>
                <Row className="mt-3">
                    {/* Tarjeta 1 */}
                    <Col md={4} className="mb-4">
                        <Card className="bg-black text-white h-100 p-3">
                            <Card.Body>
                                <Row className="align-items-center">
                                    <Col xs="auto">
                                        <CheckCircleFill size={40} className="text-danger" />
                                    </Col>
                                    <Col>
                                        <Card.Title className="mb-2">Compromiso con la calidad</Card.Title>
                                    </Col>
                                    <Card.Text className="mt-2">
                                        Nos comprometemos a ofrecer gorras de la más alta calidad, seleccionadas cuidadosamente para garantizar durabilidad y estilo.
                                    </Card.Text>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Tarjeta 2 */}
                    <Col md={4} className="mb-4">
                        <Card className="bg-black text-white h-100 p-3">
                            <Card.Body>
                                <Row className="align-items-center">
                                    <Col xs="auto">
                                        <PhoneFill size={40} className="text-danger" />
                                    </Col>
                                    <Col>
                                        <Card.Title className="mb-2">Excelencia en el servicio al cliente</Card.Title>
                                    </Col>
                                    <Card.Text className="mt-2">
                                        Nos esforzamos por proporcionar una experiencia de compra excepcional, brindando un servicio al cliente incomparable y superando las expectativas de nuestros clientes en cada interacción.
                                    </Card.Text>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* Tarjeta 3 */}
                    <Col md={4} className="mb-4">
                        <Card className="bg-black text-white h-100 p-3">
                            <Card.Body>
                                <Row className="align-items-center">
                                    <Col xs="auto">
                                        <AwardFill size={40} className="text-danger" />
                                    </Col>
                                    <Col>
                                        <Card.Title className="mb-2">Integridad y transparencia</Card.Title>
                                    </Col>
                                    <Card.Text className="mt-2">
                                        Valoramos la confianza de nuestros clientes y nos comprometemos a mantener estándares de integridad y transparencia en todas nuestras operaciones comerciales, garantizando una relación honesta y respetuosa con nuestra clientela.
                                    </Card.Text>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {/* Testimonios */}
            <Testimonials />
            {/* Contacto */}
            <Contact />
            {/* Footer */}
            <FooterPublic />
        </div>
    );
};

export default AboutUs;
